const groupedFeatureFlagsMapping: Record<string, string[]> = {
    "Image Analysis": ["imageAnalysisThumbnails", "imagePrompt", "copyPasteImages", "copyPasteImagesConfirmation", "powerPointFileProcessing"]
};

const groupFlagHelpMapping: Record<string, string> = {
    "Image Analysis": "Enable image analysis in user messages at Main & Agent chat."
};

const flagHelpMapping: Record<string, string> = {
    "imageAnalysisThumbnails": "Enable image analysis thumbnail support in the app-user-message component.",
    "copyPasteImages": "Enable copy-paste image support in the app-prompt-input component.",
    "webSearchToggleQAInputBox": "Shows the web search toggle in the QA input box using the app-web-search-toggle component. Enabled by default.",
    "enableClaude": "Switch between Claude 3.5 Sonnet and Claude 3.7 Sonnet models.",
    "enableMSsharing": "Allows an agent to be shared with a Microsoft group, even if it has already been shared with one.",
    "copyPasteImagesConfirmation": "Enables a confirmation modal when pasting images in the prompt input component.",
    "webSearchToggleDefaultOnAgentForm": "Enables the web search toggle ON by default when creating a new agent, and reflects the agent's saved web search configuration when editing.",
    "webSearchConfigurationAgentOverviewAndForm": "Shows the web search configuration in the agent overview. Changes the web search toggle to an icon in the agent form.",
    "newsBannerWebSearch": "Shows the web search news banner in the main chat (Q&A) and agent chat.",
    "katexCurrencyHandling": "INTGPT-5437: Enables custom katex delimiters to not override currency in non-katex text.",
};

const disabledToggleFlags: Record<string, string> = {
    "adminConsole": "Cannot modify. This is a required flag for the admin console.",
};

const warningFlagInfo: Record<string, string> = {
    "maintenanceMode": "Will disable all user interactions. Clear local storage to restore.",
};

const retentionPolicyChip: Record<string, string> = {
    "retentionPolicyChip": "Shows the retention policy chip in My Docs, My library, Saved Prompts & Agent",
};

export const FeatureFlagsConfig = {
    groupedFeatureFlagsMapping,
    groupFlagHelpMapping,
    flagHelpMapping,
    disabledToggleFlags,
    warningFlagInfo,
    retentionPolicyChip
};
